import type { PromptTemplateSummary } from '../types';

export const RU_SKILL_COPY: Record<string, { description?: string; examplePrompt?: string }> = {
  'audio-jingle': {
    examplePrompt:
      'Жизнерадостный 30-секундный инди-поп-джингл для запуска кофейни — теплое электропиано, щетки по барабанам, мягкий бас и один солнечный хор "ahhh" в припеве. Без вокала. Финал, удобный для зацикливания.',
    description:
      'Генерация аудио для джинглов, музыкальных подложек, закадрового голоса и звуковых эффектов. Музыкальные запросы направляются в Suno V5 / Udio / Lyria, речь — в MiniMax TTS / FishAudio / ElevenLabs V3, а SFX — в ElevenLabs SFX или AudioCraft. На выходе — файл MP3/WAV в папке проекта.',
  },
  'agent-browser': {
    examplePrompt:
      'Проверьте локальный preview Open Design через agent-browser: запустите или подключите CDP Chrome, откройте http://127.0.0.1:17573/, сообщите title, URL, видимый текст и сохраните screenshot.',
    description:
      'Автоматизация браузера для проверки локального preview Open Design. Подключается к проверенному CDP-эндпоинту Chrome, считывает отрендеренное состояние страницы, при необходимости кликает/вводит текст и сохраняет screenshot.',
  },
  'blog-post': {
    examplePrompt:
      'Развернутая статья / пост для блога — masthead, hero-изображение-заглушка, основной текст с иллюстрациями и врезками с цитатами, строка автора, связанные материалы.',
  },
  'critique': {
    examplePrompt:
      'Проведите 5-мерную критику для только что созданной презентации magazine-web-ppt — оцените философию / иерархию / детали / функцию / инновационность и дайте блоки Keep / Fix / Quick wins.',
  },
  dashboard: {
    examplePrompt:
      'Админская / аналитическая панель в одном HTML-файле.',
  },
  'dating-web': {
    examplePrompt:
      'Спроектируйте "mutuals" — сайт знакомств для авторов в X. Ежедневная дайджест-панель со статистикой, столбчатой диаграммой взаимных мэтчей и тикером сообщества.',
  },
  'design-brief': {},
  'digital-eguide': {
    examplePrompt:
      'Спроектируйте "The Creator\'s Style & Format Guide" — обложку и одну внутреннюю страницу для бренда автора lifestyle-контента.',
  },
  'docs-page': {
    examplePrompt:
      'Страница документации — левая навигация, прокручиваемая область статьи, оглавление справа.',
  },
  'open-design-landing': {
    examplePrompt:
      'Спроектируйте маркетинговый лендинг Open Design в стиле Atelier Zero / Monocle — теплая бумажная основа, сюрреалистичный коллаж из гипса и архитектуры, сверхкрупная смешанная display-типографика с курсивной антиквой, римские цифры как маркеры секций и один коралловый акцент.',
  },
  'open-design-landing-deck': {
    examplePrompt:
      'Создайте pitch deck Open Design в стиле Atelier Zero — обложка с hero-плашкой, римские разделители секций, слайд со статистикой (31 скилл · 72 системы · 12 CLI), клиентская цитата, финальный CTA и mega-italic-serif end-card. Горизонтальная свайп-пагинация как в печатном журнале.',
    description:
      'Создает однофайловую презентацию в стиле Atelier Zero: теплая бумага, акцентные spans курсивной антиквой, коралловые финальные точки, сюрреалистичные коллажные плашки. Горизонтальная журнальная пагинация с навигацией стрелками и пробелом, live HUD со счетчиком слайдов и progress bar; разделяет stylesheet и 16-слотовую библиотеку изображений с sibling-навыком `open-design-landing`.',
  },
  'email-marketing': {
    examplePrompt:
      'Спроектируйте письмо о запуске для бренда беговых кроссовок — masthead, hero-блок, крупный заголовочный lockup, сетка характеристик, CTA.',
  },
  'eng-runbook': {
    examplePrompt:
      'Напишите runbook для нашего сервиса аутентификации — алерты, дашборды, стандартные процедуры, график on-call.',
  },
  'faq-page': {
    examplePrompt:
      'Страница FAQ со складными секциями-аккордеонами, поиском и фильтрацией по категориям.',
  },
  'finance-report': {
    examplePrompt:
      'Подготовьте финансовый отчет за Q3 для early-stage SaaS — MRR, burn, gross margin, top accounts.',
  },
  'gamified-app': {
    examplePrompt:
      'Спроектируйте геймифицированное приложение для управления жизнью — мобильный мультиэкранный прототип: постер-обложка, сегодняшние квесты с XP и детализация квеста. "Daily quests for becoming a better human."',
  },
  'magazine-web-ppt': {
    examplePrompt:
      'Сделайте для меня журнальную презентацию о теме "одночеловеческие компании · организации, сжатые ИИ", выступление на 25 минут, аудитория — дизайнеры и фаундеры. Сначала предложите направление (Monocle / WIRED / Kinfolk / Domus / Lab), чтобы я мог выбрать.',
  },
  'hatch-pet': {
    examplePrompt:
      'Высидите для меня крошечного пиксельного питомца — дружелюбного сиба-ину в уютном свитере. На всем протяжении используйте навык hatch-pet.',
    description:
      'Создает, чинит, валидирует и упаковывает совместимый с Codex анимированный спрайтшит питомца (атлас 8x9, ячейки 192x208), включая QA-контактный лист, превью-видео и pet.json.',
  },
  'hr-onboarding': {
    examplePrompt:
      'Составьте 30-дневный план онбординга для нового product designer в стартапе из 40 человек.',
  },
  'html-ppt': {},
  'html-ppt-course-module': {},
  'html-ppt-graphify-dark-graph': {},
  'html-ppt-hermes-cyber-terminal': {},
  'html-ppt-knowledge-arch-blueprint': {},
  'html-ppt-obsidian-claude-gradient': {},
  'html-ppt-pitch-deck': {},
  'html-ppt-presenter-mode': {},
  'html-ppt-product-launch': {},
  'html-ppt-tech-sharing': {},
  'html-ppt-testing-safety-alert': {},
  'html-ppt-weekly-report': {},
  'html-ppt-xhs-pastel-card': {},
  'html-ppt-xhs-white-editorial': {},
  hyperframes: {
    examplePrompt:
      '5-секундный product reveal: минималистичный премиальный продукт на чистой кремовой поверхности, мягкий боковой свет, медленный наезд камеры, сдержанное движение, без текстовых оверлеев.',
    description:
      'Создает видеокомпозиции, анимации, заставки, оверлеи, субтитры, озвучку, аудиореактивную графику и переходы между сценами в HTML HyperFrames.',
  },
  'image-poster': {
    examplePrompt:
      'Редакционный постер для инди-кинофестиваля — выразительный абстрактный силуэт на теплой, слегка зернистой бумаге; набранный вручную заголовок гротеском сверху, даты фестиваля и площадка снизу моноширинным шрифтом. Приглушенная охристо-чернильная палитра.',
    description:
      'Покадровая генерация изображений для постеров, key art и редакционных иллюстраций. По умолчанию используется gpt-image-2, но сам процесс не привязан к конкретному провайдеру.',
  },
  invoice: {
    examplePrompt:
      'Создайте счет от фриланс-дизайн-студии клиенту за проект по фирменному стилю — три позиции, аванс 10%, НДС 9%.',
  },
  'kami-deck': {
    examplePrompt:
      'Создайте шестислайдовую презентацию в стиле kami (紙) — теплый пергамент, синие чернила на обложке, одно начертание антиквы, горизонтальная журнальная прокрутка.',
    description:
      'Генерирует презентацию уровня печати в дизайн-системе kami: теплый пергамент (или синие чернила для обложки и глав), антиква одного кегля, акцент синими чернилами ≤5% на слайд, без курсива. Горизонтальная пагинация как в журнале. Один самодостаточный HTML-файл, только Google Fonts.',
  },
  'kami-landing': {
    examplePrompt:
      'Спроектируйте одностраничный studio one-pager в стиле kami — пергамент, акцент синими чернилами, редакционный тон whitepaper.',
    description:
      'Создает одностраничный документ уровня печати в стиле kami (紙): теплый пергамент, акцент синими чернилами, антиква одного кегля, без курсива, без холодных серых. Читается как whitepaper или студийный one-pager, не как UI приложения. Мультиязычность (EN · zh-CN · ja). Один HTML-файл без зависимостей.',
  },
  'kanban-board': {
    examplePrompt:
      'Создайте канбан-доску для growth-команды из 5 человек в середине спринта — Backlog, Doing, Review, Done.',
  },
  'live-artifact': {
    examplePrompt:
      'Создайте интерактивный live-артефакт с карточками статуса, таблицей данных и панелью деталей, которая реагирует на изменение выбора.',
  },
  'magazine-poster': {
    examplePrompt:
      'Спроектируйте редакционный постер в журнальной эстетике — "You don\'t need a designer to ship your first draft anymore." Газетная бумага, шесть пронумерованных секций.',
  },
  'meeting-notes': {
    examplePrompt:
      'Напишите заметки по 60-минутной еженедельной встрече команды роста — повестка, решения, action items с ответственными, следующая встреча.',
  },
  'mobile-app': {
    examplePrompt:
      'Экран мобильного приложения, показанный внутри точного по пикселям корпуса iPhone 15 Pro.',
  },
  'mobile-onboarding': {
    examplePrompt:
      'Спроектируйте мобильный onboarding из 3 экранов для приложения по медитации — Welcome, Value Props, Sign-in.',
  },
  'motion-frames': {
    examplePrompt:
      'Спроектируйте анимированный hero-блок — вращающееся типографическое кольцо вокруг каркасного глобуса, с заголовком "Reach every country." Зацикливание на 12 с, готово к экспорту в HyperFrames.',
  },
  'pm-spec': {
    examplePrompt:
      'Напишите мне PRD для two-factor authentication в нашем SaaS-приложении — problem, scope, milestones, open questions.',
  },
  'pptx-html-fidelity-audit': {
    examplePrompt:
      'Сравните deck.pptx и deck.html, перечислите расхождения в верстке (переполнение футера, пропавший курсив, hero-блок не отцентрован) и заново экспортируйте с footer rail и cursor flow.',
  },
  'pricing-page': {
    examplePrompt:
      'Отдельная pricing page — header, тарифные уровни, сравнительная таблица функций и FAQ.',
  },
  'replit-deck': {
    examplePrompt:
      'Однофайловая HTML-колода с горизонтальным свайпом в духе галереи шаблонов лендингов Replit Slides.',
  },
  'saas-landing': {
    examplePrompt:
      'Одностраничный SaaS-лендинг с hero-блоком, features, social proof, pricing и CTA.',
  },
  'simple-deck': {
    examplePrompt:
      'Однофайловая HTML-колода с горизонтальным свайпом.',
  },
  'social-carousel': {
    examplePrompt:
      'Спроектируйте кинематографичную карусель из 3 карточек — "onwards.", "to the next one.", "looking ahead.". Квадраты 1080x1080, сразу готово для Instagram.',
  },
  'sprite-animation': {
    examplePrompt:
      'Сделайте спрайтовую анимацию с короткими фактами об истории Nintendo. Сочетайте пиксельного маскота, анимированный текст и акцент в духе hanafuda. Цвет и типографика должны ощущаться как у бренда Nintendo.',
  },
  'team-okrs': {
    examplePrompt:
      'Сделайте OKR-трекер на Q4 — три objectives, у каждого по три key results, progress bars, ответственные, статус-пиллы.',
  },
  tweaks: {
    examplePrompt:
      'Добавьте к этому лендингу панель настроек — Accent Color, Type Scale, Density, Light/Dark — и сохраняйте выбор в localStorage, чтобы он не пропадал после обновления страницы.',
  },
  'video-shortform': {
    examplePrompt:
      '5-секундный product reveal — керамическая кофейная кружка вращается на мягком бумажном фоне, теплый боковой свет слева, мелкие пылинки парят в луче света. Кинематографично, 16:9, медленный дрейф камеры.',
    description:
      'Генерация коротких видео длительностью 3-10 секунд для product reveal, motion teasers и атмосферных зацикленных роликов.',
  },
  'web-prototype': {
    examplePrompt:
      'Универсальный прототип для desktop web.',
  },
  'weekly-update': {
    examplePrompt:
      'Сделайте презентацию еженедельного обновления для команды роста — что завершено, что в работе, блокеры, метрики и вопросы на следующую неделю.',
  },
  'wireframe-sketch': {
    examplePrompt:
      'Набросайте hand-drawn wireframe v0.1 для портала — четыре варианта во вкладках на миллиметровке, заголовки маркером, заметки на стикерах, заштрихованные заглушки графиков.',
  },
};

export const RU_DESIGN_SYSTEM_SUMMARIES: Record<string, string> = {
  airbnb: 'Маркетплейс путешествий. Теплый коралловый акцент, опора на фотографию, скругленный UI.',
  airtable: 'Гибрид таблицы и базы данных. Ярко, дружелюбно, с эстетикой структурированных данных.',
  apple: 'Потребительская электроника. Премиальный воздух, SF Pro, кинематографичная подача.',
  'atelier-zero':
    'Редакционная студийная система. Теплое бумажное полотно, сюрреалистичный коллаж из гипса и архитектуры, смешанная display-типографика с курсивной антиквой, римские цифры как маркеры секций и один коралловый акцент — для журнальных лендингов, сайтов студий и manifesto-страниц.',
  binance: 'Криптобиржа. Сильный желтый акцент на монохроме, энергетика trading floor.',
  bmw: 'Премиальный автопром. Темные статусные поверхности, точная немецкая инженерная эстетика.',
  bugatti: 'Бренд гиперкаров. Кинематографично темное полотно, монохромная строгость, монументальная display-типографика.',
  cal: 'Open-source-планирование встреч. Чистый нейтральный UI, простота для разработчиков.',
  claude: 'ИИ-ассистент Anthropic. Теплый терракотовый акцент, чистая редакционная композиция.',
  clay: 'Креативное агентство. Органические формы, мягкие градиенты, art-directed layout.',
  clickhouse: 'Быстрая аналитическая БД. Техническая документарная эстетика с желтым акцентом.',
  cohere: 'Корпоративная AI-платформа. Живые градиенты, насыщенная dashboard-эстетика.',
  coinbase: 'Криптобиржа. Чистая синяя айдентика, акцент на доверии, институциональное ощущение.',
  composio: 'Платформа интеграции инструментов. Современная темная база с цветными иконками интеграций.',
  cursor: 'AI-first редактор кода. Лаконичный темный интерфейс, акцентные градиенты.',
  default:
    'Чистый продуктовый дефолт. Подходит, когда бриф не задает конкретного настроения — для B2B-инструментов, дашбордов и утилитарных страниц.',
  elevenlabs: 'Платформа AI-голоса. Темный кинематографичный UI, эстетика аудиоволн.',
  expo: 'Платформа React Native. Темная тема, плотный трекинг, кодоцентричная подача.',
  ferrari: 'Премиальный автопром. Редакционный chiaroscuro, акценты Ferrari Red, кинематографичный черный.',
  figma: 'Совместный дизайн-инструмент. Яркая многокрасочность, игриво и профессионально.',
  framer: 'Конструктор сайтов. Смелый черный и синий, приоритет motion, дизайн-ориентированность.',
  hashicorp: 'Автоматизация инфраструктуры. Чистый enterprise-визуал, черно-белая строгость.',
  ibm: 'Корпоративные технологии. Carbon Design System, структурированная синяя палитра.',
  intercom: 'Клиентские коммуникации. Дружелюбная синяя палитра, разговорные UI-паттерны.',
  kami:
    'Редакционная бумажная система. Теплое пергаментное полотно, чернильно-синий акцент, антиква в одном начертании — для резюме, one-pager, white paper, портфолио и deck.',
  kraken: 'Криптотрейдинг. Темный UI с фиолетовым акцентом, насыщенные данными дашборды.',
  lamborghini: 'Бренд суперкаров. Абсолютно черные поверхности, золотые акценты, драматичная капительная типографика.',
  'linear-app': 'Управление проектами. Ультраминимализм, точность, фиолетовый акцент.',
  loom: 'Асинхронные видеосообщения. Фиолетовый primary, малиновый акцент, светлый UI с белыми поверхностями для видеосвязи.',
  lovable: 'AI-конструктор full-stack-продуктов. Игривые градиенты, дружелюбная эстетика для разработчиков.',
  mastercard: 'Глобальная платежная сеть. Теплое кремовое полотно, орбитальные pill-формы, редакционное тепло.',
  meta: 'Тех-ритейл. Опора на фотографию, бинарные светлые/темные поля, CTA в Meta Blue.',
  minimax: 'Поставщик AI-моделей. Смелая темная поверхность с неоновыми акцентами.',
  mintlify: 'Платформа документации. Чисто, с зеленым акцентом, оптимизировано для чтения.',
  miro: 'Визуальная коллаборация. Светлый желтый акцент, эстетика бесконечного холста.',
  'mistral-ai': 'Поставщик open-weight LLM. Французски выверенный минимализм с фиолетовым оттенком.',
  mongodb: 'Документная БД. Зеленая leaf-айдентика, акцент на документации для разработчиков.',
  nike: 'Спортивный ритейл. Монохромный UI, массивный верхний регистр, full-bleed-фотография.',
  notion: 'Единое рабочее пространство. Теплый минимализм, серифные заголовки, мягкие поверхности.',
  nvidia: 'GPU-компьютинг. Черно-зеленая энергия, техническая силовая эстетика.',
  ollama: 'Локальный запуск LLM. Terminal-first, монохромная простота.',
  'opencode-ai': 'Платформа AI-кодинга. Dev-centered темная тема.',
  pinterest: 'Визуальное открытие. Красный акцент, masonry grid, упор на изображения.',
  playstation:
    'Ритейл игровых консолей. Трехплоскостная channel-композиция, спокойная авторитетность в display-типографике, циановый hover-scale.',
  posthog: 'Product analytics. Игривый брендинг, дружелюбный к разработчикам темный UI.',
  raycast: 'Лаунчер продуктивности. Лаконичный темный chrome, живые градиентные акценты.',
  renault: 'Французский автопром. Живые aurora-градиенты, типографика NouvelR, сильная энергия.',
  replicate: 'Запуск ML-моделей через API. Чистое белое полотно, кодоцентричность.',
  resend: 'Email API. Минималистичная темная тема, моноширинные акценты.',
  revolut: 'Цифровой банкинг. Лаконичная темная поверхность, градиентные карты, fintech-точность.',
  runwayml: 'AI-видеогенерация. Кинематографичный темный UI, медийно насыщенный layout.',
  sanity: 'Headless CMS. Красный акцент, content-first редакционная композиция.',
  sentry: 'Мониторинг ошибок. Темный dashboard, плотность данных, розово-фиолетовый акцент.',
  shopify: 'E-commerce-платформа. Dark-first и кинематографично, неоново-зеленый акцент, сверхлегкая типографика.',
  spacex: 'Космические технологии. Строгий черно-белый язык, full-bleed-изображения, футуризм.',
  spotify: 'Музыкальный стриминг. Яркий зеленый на темном, жирная типографика, опора на обложки.',
  starbucks:
    'Глобальный кофейный ритейл. Четырехступенчатая зеленая система, теплое кремовое полотно, кнопки full pill.',
  stripe: 'Платежная инфраструктура. Фирменные фиолетовые градиенты, элегантность weight-300.',
  supabase: 'Open-source-альтернатива Firebase. Темная изумрудная тема, code-first.',
  superhuman: 'Быстрый почтовый клиент. Премиальный темный UI, keyboard-first, фиолетовое свечение.',
  tesla: 'Электромобили. Радикальная редукция, полноэкранная фотография, почти отсутствие UI.',
  theverge:
    'Тех-издание. Акценты acid mint и ultraviolet, display Manuka, карточки сюжетов в духе rave-flyer.',
  'together-ai': 'Open-source AI-инфраструктура. Технический язык, дизайн в духе blueprint.',
  'trading-terminal': 'Финансовый терминал. Data-dense интерфейс в стиле Bloomberg, только темный режим.',
  uber: 'Платформа мобильности. Сильный черно-белый контраст, узкая типографика, городская энергия.',
  vercel: 'Frontend-деплой. Черно-белая точность, шрифт Geist.',
  vodafone: 'Глобальный телеком-бренд. Монументальная display-типографика в верхнем регистре, красные chapter bands Vodafone.',
  voltagent: 'Фреймворк AI-агентов. Void-черное полотно, изумрудный акцент, терминальная нативность.',
  'warm-editorial':
    'Журнальная эстетика под антикву. Терракотовый акцент на теплой off-white-бумаге — для long-form, editorial и брендовых маркетинговых страниц.',
  warp: 'Современный терминал. Темная IDE-подобная поверхность, командный UI из блоков.',
  webflow: 'Визуальный конструктор сайтов. Синие акценты, полированная эстетика маркетингового сайта.',
  wired: 'Тех-журнал. Газетная плотность на бумажно-белом фоне, custom display-антиква, mono-kicker, чернильно-синие ссылки.',
  wise: 'Денежные переводы. Яркий зеленый акцент, дружелюбно и ясно.',
  'x-ai': 'AI-лаборатория Илона Маска. Строгий монохром, футуристический минимализм.',
  xiaohongshu: 'Lifestyle UGC-соцсеть. Единый фирменный красный, щедрый радиус, content-first.',
  wechat: 'Мини-программы WeChat. Свежий зелёный (#07C160), PingFang SC, UI с чат-пузырями, панель вкладок.',
  zapier: 'Платформа автоматизации. Теплый оранжевый, дружелюбная иллюстративная подача.',
};

export const RU_DESIGN_SYSTEM_CATEGORIES: Record<string, string> = {
  Starter: 'Стартовые',
  'AI & LLM': 'AI & LLM',
  'Bold & Expressive': 'Смелые и выразительные',
  'Creative & Artistic': 'Креативные и художественные',
  'Developer Tools': 'Инструменты для разработчиков',
  'Layout & Structure': 'Композиция и структура',
  'Modern & Minimal': 'Современные и минималистичные',
  'Morphism & Effects': 'Морфизм и эффекты',
  'Productivity & SaaS': 'Продуктивность и SaaS',
  'Professional & Corporate': 'Профессиональные и корпоративные',
  'Backend & Data': 'Бэкенд и данные',
  'Design & Creative': 'Дизайн и креатив',
  'Fintech & Crypto': 'Финтех и крипто',
  'E-Commerce & Retail': 'Электронная коммерция и ритейл',
  'Media & Consumer': 'Медиа и потребительские',
  'Social & Messaging': 'Социальные сети и мессенджеры',
  Automotive: 'Автомобили',
  'Editorial & Print': 'Редакционные и печатные',
  'Editorial · Studio': 'Редакционная студия',
  'Retro & Nostalgic': 'Ретро и ностальгия',
  'Themed & Unique': 'Тематические и уникальные',
  'Editorial / Personal / Publication': 'Редакционные / Персональные / Публикации',
  Uncategorized: 'Без категории',
};

export const RU_PROMPT_TEMPLATE_CATEGORIES: Record<string, string> = {
  Infographic: 'Инфографика',
  'Anime / Manga': 'Аниме / манга',
  'App / Web Design': 'Дизайн приложений / веба',
  'Game UI': 'Игровой UI',
  Illustration: 'Иллюстрация',
  'Profile / Avatar': 'Профиль / аватар',
  'Social Media Post': 'Пост для соцсетей',
  General: 'Общее',
  Advertising: 'Реклама',
  'Motion Graphics': 'Моушен-графика',
  Cinematic: 'Кинематографичное',
  'VFX / Fantasy': 'VFX / фэнтези',
  Anime: 'Аниме',
  'Social / Meme': 'Соцсети / мемы',
  Branding: 'Брендинг',
  Data: 'Данные',
  Marketing: 'Маркетинг',
  Product: 'Продукт',
  'Short Form': 'Короткий формат',
  Travel: 'Путешествия',
  'Live Artifact': 'Live-артефакт',
  'VFX / HTML-in-Canvas': 'VFX / HTML-in-Canvas',
};

export const RU_PROMPT_TEMPLATE_TAGS: Record<string, string> = {
  '3d': '3D',
  '3d-render': '3D-рендер',
  action: 'Экшен',
  'ancient-china': 'Древний Китай',
  anime: 'Аниме',
  'app-showcase': 'Демонстрация приложения',
  archery: 'Стрельба из лука',
  arpg: 'ARPG',
  'audio-reactive': 'Аудиореактивный',
  'boss-fight': 'Битва с боссом',
  brand: 'Бренд',
  branding: 'Брендинг',
  captions: 'Субтитры',
  cavalry: 'Кавалерия',
  chart: 'Диаграмма',
  childlike: 'Детский',
  choreography: 'Хореография',
  cinematic: 'Кинематографично',
  'cinematic-romance': 'Киноромантика',
  combat: 'Бой',
  combo: 'Комбо',
  'companion-to-image': 'Дополнение к изображению',
  counter: 'Счетчик',
  crayon: 'Восковой мелок',
  cyberpunk: 'Киберпанк',
  dance: 'Танец',
  'data-viz': 'Визуализация данных',
  editorial: 'Редакционный',
  'elden-ring': 'Elden Ring',
  endcard: 'Финальная заставка',
  escort: 'Сопровождение',
  'escort-mission': 'Миссия сопровождения',
  fantasy: 'Фэнтези',
  fashion: 'Мода',
  'fighting-game': 'Файтинг',
  food: 'Еда',
  'game-cinematic': 'Игровой синематик',
  'game-ui': 'Игровой UI',
  'grid-sheet': 'Сетка',
  guanyu: 'Гуань Юй',
  'hand-drawn': 'Ручной рисунок',
  hud: 'HUD',
  'hud-safe': 'Безопасная зона HUD',
  hype: 'Хайп',
  hyperframes: 'HyperFrames',
  idol: 'Айдол',
  illustration: 'Иллюстрация',
  'image-to-image': 'Редактирование по изображению',
  infographic: 'Инфографика',
  japanese: 'Японский',
  karaoke: 'Караоке',
  'key-visual': 'Ключевой визуал',
  'kinetic-typography': 'Кинетическая типографика',
  'linear-style': 'Стиль Linear',
  'live-artifact': 'Live-артефакт',
  logo: 'Логотип',
  lyubu: 'Люй Бу',
  map: 'Карта',
  marketing: 'Маркетинг',
  minimal: 'Минимализм',
  mmo: 'MMO',
  mobile: 'Мобильный',
  money: 'Деньги',
  'mounted-combat': 'Конный бой',
  nature: 'Природа',
  'open-world': 'Открытый мир',
  'otaku-dance': 'Отаку-танец',
  outro: 'Аутро',
  overlay: 'Оверлей',
  pipeline: 'Пайплайн',
  'pose-reference': 'Референс позы',
  portrait: 'Портрет',
  product: 'Продукт',
  'product-promo': 'Промо продукта',
  rework: 'Переработка',
  route: 'Маршрут',
  saas: 'SaaS',
  sequence: 'Последовательность',
  sizzle: 'Сиззл-ролик',
  social: 'Соцсети',
  storyboard: 'Сториборд',
  'street-fighter': 'Street Fighter',
  'style-transfer': 'Перенос стиля',
  tekken: 'Tekken',
  'three-kingdoms': 'Троецарствие',
  tiktok: 'TikTok',
  'title-card': 'Титульная заставка',
  transform: 'Трансформация',
  travel: 'Путешествия',
  tts: 'TTS',
  typography: 'Типографика',
  'unreal-engine-5': 'Unreal Engine 5',
  vertical: 'Вертикальный',
  'video-reference': 'Видео-референс',
  'vs-screen': 'VS-экран',
  'website-to-video': 'Сайт-в-видео',
  wuxia: 'Уся',
  zhaoyun: 'Чжао Юнь',
  dashboard: 'Дашборд',
  data: 'Данные',
  destruction: 'Разрушение',
  displacement: 'Смещение',
  hero: 'Главный герой',
  'html-in-canvas': 'HTML-в-Canvas',
  iphone: 'iPhone',
  keynote: 'Keynote',
  liquid: 'Жидкость',
  'liquid-glass': 'Liquid Glass',
  macbook: 'MacBook',
  magnetic: 'Магнитный',
  particles: 'Частицы',
  portal: 'Портал',
  'product-demo': 'Демо продукта',
  shader: 'Шейдер',
  shatter: 'Раскалывание',
  text: 'Текст',
  webgl: 'WebGL',
};

export const RU_PROMPT_TEMPLATE_COPY: Record<string, Partial<Pick<PromptTemplateSummary, 'summary' | 'title'>>> = {
  '3d-stone-staircase-evolution-infographic': {
    title: '3D-инфографика эволюции в виде каменной лестницы',
    summary:
      'Преобразует плоскую временную шкалу эволюции в реалистичную 3D-инфографику в виде каменной лестницы с детализированными рендерами организмов и структурированными боковыми панелями.',
  },
  'anime-martial-arts-battle-illustration': {
    title: 'Аниме-иллюстрация с боем в стиле martial arts',
    summary:
      'Создает динамичную, эффектную аниме-иллюстрацию двух девушек, сражающихся в традиционном додзе на фоне стихийных энергетических эффектов.',
  },
  'e-commerce-live-stream-ui-mockup': {
    title: 'Макет UI для e-commerce-стрима',
    summary:
      'Создает реалистичный интерфейс соцсетевого лайвстрима поверх портретного кадра, включая настраиваемый чат, всплывающие подарки и карточку покупки товара.',
  },
  'illustrated-city-food-map': {
    title: 'Иллюстрированная гастрономическая карта города',
    summary:
      'Создает нарисованную от руки туристическую карту в акварельной манере с пронумерованными локальными специалитетами, достопримечательностями и легендой.',
  },
  'infographic-otaku-dance-choreography-breakdown-gokurakujodo-16-panels': {},
  'momotaro-explainer-slide-in-hybrid-style': {
    title: 'Объясняющий слайд о Момотаро в гибридном стиле',
    summary:
      'Соединяет простую теплую эстетику иллюстраций Irasutoya с высокой информационной плотностью японских ведомственных объясняющих слайдов.',
  },
  'profile-avatar-anime-girl-to-cinematic-photo': {
    title: 'Профиль / аватар - от аниме-девушки к кинематографичному фото',
    summary:
      'Преобразует иллюстрацию персонажа в реалистичный теплый интерьерный портрет в винтажной тональности, сохраняя одежду, позу и кошку.',
  },
  'profile-avatar-casual-fashion-grid-photoshoot': {
    title: 'Профиль / аватар - casual fashion grid-фотосессия',
    summary:
      'Структурированный JSON-промпт для коллажа из 4 кадров повседневной fashion-съемки с детализированными параметрами персонажа и света.',
  },
  'profile-avatar-cinematic-south-asian-male-portrait-with-vultures': {
    title: 'Профиль / аватар - кинематографичный портрет южноазиатского мужчины с грифами',
    summary:
      'Детализированный кинематографичный портрет молодого южноазиатского мужчины в мрачной фэнтези-сцене, окруженного грифами и воронами.',
  },
  'profile-avatar-cyberpunk-anime-portrait-with-neon-face-text': {
    title: 'Профиль / аватар - киберпанк-аниме-портрет с неоновым текстом на лице',
    summary:
      'Стильный неоновый аниме-портрет для постера, арта для соцсетей или футуристических бренд-визуалов.',
  },
  'profile-avatar-elegant-fantasy-girl-in-violet-garden': {
    title: 'Профиль / аватар - элегантная фэнтези-героиня в фиолетовом саду',
    summary:
      'Создает выверенный аниме-фэнтези-портрет элегантной девушки с блестяще уложенными волосами, фиолетово-черным образом и волшебным цветочным садом.',
  },
  'profile-avatar-ethereal-blue-haired-fantasy-portrait': {
    title: 'Профиль / аватар - эфирный фэнтези-портрет с голубыми волосами',
    summary:
      'Создает мягкий сияющий аниме-фэнтези-портрет для вертикального key art или изящных иллюстраций персонажа с струящимися волосами.',
  },
  'profile-avatar-glamorous-woman-in-black-portrait': {
    title: 'Профиль / аватар - гламурный женский портрет в черном',
    summary:
      'Создает фотореалистичный люксовый портрет элегантной женщины в черном образе, подходящий для fashion editorials и beauty-визуалов.',
  },
  'profile-avatar-hyper-realistic-selfie-texture-prompts': {
    title: 'Профиль / аватар - гиперреалистичные промпты для текстуры селфи',
    summary:
      'Детализированные заготовки промптов для реалистичных текстур кожи и естественного кадрирования смартфонного селфи с видимыми порами и мягким дневным светом.',
  },
  'profile-avatar-lavender-fantasy-mage-portrait': {
    title: 'Профиль / аватар - лавандовый портрет фэнтези-магессы',
    summary:
      'Создает выверенный аниме-фэнтези-портрет элегантной принцессы-магессы со светлыми волосами, фиолетовыми цветами и платьем, напоминающим кристаллы.',
  },
  'profile-avatar-monochrome-studio-portrait': {
    title: 'Профиль / аватар - монохромный студийный портрет',
    summary:
      'Премиальный промпт для коммерческой съемки монохромного портрета с выразительным разделенным фоном и драматичным студийным светом.',
  },
  'profile-avatar-old-photo-restoration-to-dslr-portrait': {
    title: 'Профиль / аватар - реставрация старого фото в DSLR-портрет',
    summary:
      'Восстанавливает поврежденное винтажное семейное фото с четырьмя людьми в чистый, раскрашенный и высокодетализированный реалистичный портрет.',
  },
  'profile-avatar-poetic-woman-in-garden-portrait': {
    title: 'Профиль / аватар - поэтичный женский портрет в саду',
    summary:
      'Создает реалистичный editorial-портрет читающей молодой женщины в солнечном саду — для lifestyle-фотографии или literary branding.',
  },
  'profile-avatar-professional-identity-portrait-wallpaper': {
    title: 'Профиль / аватар - обои с профессиональным имиджевым портретом',
    summary:
      'Создает премиальные обои высокого разрешения с человеком в профессиональном образе, рабочими действиями и типографикой.',
  },
  'profile-avatar-realistically-imperfect-ai-selfie': {
    title: 'Профиль / аватар - намеренно несовершенное AI-селфи',
    summary:
      'Креативный GPT-Image-2-промпт для "неудачного" селфи, которое выглядит как случайный смартфонный снимок низкого качества.',
  },
  'profile-avatar-signed-marker-portrait-on-shikishi': {
    title: 'Профиль / аватар - подписанный маркерный портрет на сикиси',
    summary:
      'Создает яркий подписанный маркерный портрет на квадратной доске shikishi — для фан-арта с автографом и персональных благодарственных визуалов.',
  },
  'profile-avatar-snow-rabbit-empress-portrait': {
    title: 'Профиль / аватар - портрет императрицы снежного кролика',
    summary:
      'Реалистичный фэнтези-промпт для царственного женского образа с мотивами кролика в зимнем ханьфу на фоне заснеженного горного храма.',
  },
  'profile-avatar-snow-rabbit-mask-hanfu-portrait': {
    title: 'Профиль / аватар - портрет в ханьфу и маске снежного кролика',
    summary:
      'Создает кинематографичный зимний фэнтези-портрет женщины в белом ханьфу и маске с кроличьим мотивом — для изящного character art.',
  },
  'profile-avatar-snowy-rabbit-hanfu-portrait': {
    title: 'Профиль / аватар - заснеженный портрет в ханьфу с кроличьим мотивом',
    summary:
      'Создает ультрадетализированный фэнтези beauty-портрет женщины с кроличьими ушами в расшитом ханьфу — для character art и costume design.',
  },
  'profile-avatar-snowy-rabbit-spirit-portrait': {
    title: 'Профиль / аватар - заснеженный портрет духа-кролика',
    summary:
      'Создает спокойный фэнтези-портрет безымянной женщины с кроличьими ушами в зимнем антураже — для атмосферного character art.',
  },
  'profile-avatar-song-dynasty-hanfu-portrait': {
    title: 'Профиль / аватар - портрет в ханьфу эпохи Сун',
    summary:
      'Оптимизированный промпт для детализированного реалистичного портрета красавицы в традиционном ханьфу династии Сун в древнем дворцовом окружении.',
  },
  'social-media-post-anime-pokemon-shop-outfit-teaser-poster': {
    title: 'Пост для соцсетей - аниме-тизер наряда в магазине Pokemon',
    summary:
      'Создает мягкий пастельный аниме-fashion-постер с размытым лицом в интерьере магазина Pokemon.',
  },
  'social-media-post-cinematic-elevator-scene': {
    title: 'Пост для соцсетей - кинематографичная сцена в лифте',
    summary:
      'Промпт для мрачной кинематографичной сцены с женщиной в металлическом лифте, с реалистичным светом и отражениями.',
  },
  'social-media-post-confused-elf-girl-at-pastel-desk': {
    title: 'Пост для соцсетей - растерянная эльфийка за пастельным столом',
    summary:
      'Создает мягкую пастельную аниме-иллюстрацию эльфийки за компьютером в уютном kawaii-рабочем пространстве.',
  },
  'social-media-post-editorial-fashion-photography': {
    title: 'Пост для соцсетей - editorial fashion-фотография',
    summary:
      'Атмосферный промпт с акцентом на моду для минималистичной студийной сцены с мягким светом и теплыми тонами.',
  },
  'social-media-post-fashion-editorial-collage': {
    title: 'Пост для соцсетей - fashion editorial-коллаж',
    summary:
      'Высокодетализированный промпт для фотоколлажа 2x2 из editorial fashion-съемки с единым стайлингом, точно заданным светом и референсным лицом.',
  },
  'social-media-post-psg-transfer-announcement-poster': {
    title: 'Пост для соцсетей - постер о трансфере в PSG',
    summary:
      'Яркий профессиональный футбольный постер о подписании игрока для объявления о переходе в Paris Saint-Germain.',
  },
  'social-media-post-showa-day-retro-culture-magazine-cover': {
    title: 'Пост для соцсетей - ретро-культурная журнальная обложка ко Дню Сёва',
    summary:
      'Теплая редакционная страница о японском празднике с аниме-артом, ностальгической уличной сценой эпохи Сёва и журнальной версткой.',
  },
  'social-media-post-social-media-fashion-outfit-generation': {
    title: 'Пост для соцсетей - генерация fashion-образов',
    summary:
      'Промпт для создания недельной подборки образов fashion-блогера на основе профиля персонажа, с подписями брендов и ценами.',
  },
  'social-media-post-travel-snapshot-collage-prompt': {
    title: 'Пост для соцсетей - коллаж из travel-снимков',
    summary:
      'Детализированный промпт для ностальгического коллажа из 12 кадров, похожих на смартфонные фото из одиночного путешествия.',
  },
  'social-media-post-vintage-sign-painter-sketch': {
    title: 'Пост для соцсетей - винтажный эскиз вывески от sign painter',
    summary:
      'Создает нарисованный маркером эскиз на бумаге с реалистичными деталями вроде графитных линий и наплывов чернил.',
  },
  'vr-headset-exploded-view-poster': {
    title: 'Постер со взрывной схемой VR-гарнитуры',
    summary:
      'Создает технологичную взрывную схему VR-гарнитуры с детализированными выносками компонентов и рекламным текстом.',
  },
  '3d-animated-boy-building-lego': {
    title: '3D-анимированный мальчик собирает Lego',
    summary:
      'Промпт для многокадрового видео в стиле 3D-анимации о мальчике, который аккуратно собирает Lego в комнате, включая эффекты time-lapse.',
  },
  'a-decade-of-refinement-glow-up': {
    title: 'Десять лет шлифовки: glow-up',
    summary:
      'Трансформационный промпт для Seedance 2.0, который проводит мужчину от расслабленного сеттинга 2016 года к роскошному лайфстайлу Дубая 2026 года.',
  },
  'ancient-guardian-dragon-rescue': {
    title: 'Спасение древним драконом-хранителем',
    summary:
      'Детализированный кинематографичный multi-shot-промпт о девочке в дождливой деревне, которую спасает появившийся дракон.',
  },
  'ancient-indian-kingdom-fpv-video': {
    title: 'FPV-видео древнего индийского царства',
    summary:
      'Быстрый кинематографичный FPV-дрон-промпт, показывающий мистическое индийское царство с храмами и джунглями.',
  },
  'animation-transfer-and-camera-tracking-prompt': {
    title: 'Промпт для animation transfer и camera tracking',
    summary:
      'Технический промпт для Seedance 2.0, который переносит заданный референс движения на персонажа и одновременно удерживает стабильный tracking камеры.',
  },
  'beat-synced-outfit-transformation-dance': {
    title: 'Танец с beat-synced трансформацией костюма',
    summary:
      'Промпт для Seedance 2.0, где персонаж танцует по breakdown-кадрам и синхронно с битом меняет образ.',
  },
  'character-intro-motion-graphics-sequence': {
    title: 'Motion-graphics-секвенция знакомства с персонажем',
    summary:
      'Сложный многосоставный motion-graphics-промпт для представления команды персонажей с UI-оверлеями и переходами.',
  },
  'cinematic-birthday-celebration-sequence': {
    title: 'Кинематографичная секвенция празднования дня рождения',
    summary:
      'Высокодетализированный multi-shot-видеопромпт для сцены дня рождения с упором на консистентность персонажей и эмоциональный сторителлинг.',
  },
  'cinematic-dragon-interaction-flight': {
    title: 'Кинематографичное взаимодействие с драконом и полет',
    summary:
      'Детализированный storyboard-промпт для видео с эмоциональным взаимодействием женщины и дракона, за которым следует кинематографичный полет.',
  },
  'cinematic-east-asian-woman-hand-dance': {
    title: 'Кинематографичный танец рук восточноазиатской женщины',
    summary:
      'Высокодетализированный кинематографичный multi-shot-видеопромпт для стилизованного танца рук с поминутными указаниями по камере и действию.',
  },
  'cinematic-emotional-face-close-up': {
    title: 'Кинематографичный эмоциональный крупный план лица',
    summary:
      'Высокодетализированный технический промпт для Seedance 2.0 с упором на реалистичные текстуры кожи и сложные эмоциональные переходы на лице.',
  },
  'cinematic-marine-biologist-exploration': {
    title: 'Кинематографичное исследование морского биолога',
    summary:
      'Детализированный кинематографичный видеопромпт для подводной сцены, где морской биолог обнаруживает старый затонувший корабль в коралловом рифе.',
  },
  'cinematic-music-podcast-and-guitar-technique': {
    title: 'Кинематографичный музыкальный подкаст и гитарная техника',
    summary:
      'Продвинутый кинематографичный промпт для 4K-видео музыкального подкаста с фокусом на гитарную технику, pinch harmonics и студийную эстетику.',
  },
  'cinematic-route-navigation-guide': {
    title: 'Кинематографичный гид по маршруту',
    summary:
      'Структурированный multi-scene-промпт для Seedance, создающий консистентное walking-navigation-видео с повторяющимся гидом.',
  },
  'cinematic-street-racing-sequence-for-seedance-2': {
    title: 'Кинематографичная street-racing-секвенция для Seedance 2',
    summary:
      'Детализированный multi-shot-промпт для ночной street-racing-сцены с интенсивным фокусом на водителе, динамичной камерой и взрывным разгоном.',
  },
  'cinematic-vampire-alley-fight-sequence': {
    title: 'Кинематографичная вампирская драка в переулке',
    summary:
      'Развернутый экшен-промпт для сцены короткометражки с динамичной камерой и скоростным боем в неоновом переулке.',
  },
  'crimson-horizon-sci-fi-cinematic-sequence': {
    title: 'Кинематографичная sci-fi-секвенция Crimson Horizon',
    summary:
      'Полноценная 9-shot-кинематографическая последовательность для sci-fi-фильма "Crimson Horizon" — от запуска ракеты до тревожной встречи с пришельцем на Марсе.',
  },
  'cyberpunk-game-trailer-script': {
    title: 'Сценарий трейлера киберпанк-игры',
    summary:
      'Развернутый видеопромпт для трейлера киберпанк-игры с character design, UI-анимациями и сменой окружения от белого void к фавеле.',
  },
  'forbidden-city-cat-satire': {
    title: 'Сатира с котом в Запретном городе',
    summary:
      'Сложный dark comedy-промпт для Seedance 2.0 с рыжим котом-чиновником и императором-гиеной в сатирической сцене времен Цин.',
  },
  'game-screenshot-anime-fighting-game-captain-ryuuga-vs-kaze-renshin': {},
  'game-screenshot-three-kingdoms-guanyu-slaying-yanliang': {},
  'game-screenshot-three-kingdoms-lyubu-yuanmen-archery': {},
  'game-screenshot-three-kingdoms-zhaoyun-cradle-escape': {},
  'hollywood-haute-couture-fantasy-video-prompt': {
    title: 'Фэнтези-видеопромпт в духе Hollywood haute couture',
    summary:
      'Детализированный multi-scene-видеопромпт для Seedance 2.0, рассчитанный на фэнтези-фильм в эстетике Hollywood haute couture с 8K / Unreal Engine.',
  },
  'hyperframes-app-showcase-three-phones': {
    title: 'HyperFrames: 12-секундная демонстрация приложения — три парящих телефона',
    summary:
      '12-секундная композиция 16:9 для демонстрации приложения — три парящих экрана iPhone висят в 3D-пространстве и по очереди вращаются, показывая разные функции; есть beat-синхронные label-callout\'ы и финальный logo lockup. Напрямую построено на каталожном блоке HyperFrames `app-showcase`.',
  },
  'hyperframes-brand-sizzle-reel': {
    title: 'HyperFrames: 30-секундный брендовый sizzle reel',
    summary:
      '30-секундный sizzle reel HyperFrames в формате 16:9 — быстрый монтаж, beat-синхронная кинетическая типографика, audio-reactive масштабирование ключевых слов, shader-переходы между пятью сценами и финальная end card с bloom-логотипом. Смоделировано по архетипу aisoc-hype из Student Kit.',
  },
  'hyperframes-data-bar-chart-race': {
    title: 'HyperFrames: анимированная гонка столбчатых диаграмм в стиле NYT',
    summary:
      '12-секундная инфографика 16:9 — анимированные столбики и линейный график с поэтапным раскрытием категорий, serif-заголовком в духе NYT, сноской с источником и кинетическими метками значений. Напрямую построено на каталожном блоке HyperFrames `data-chart`.',
  },
  'hyperframes-flight-map-route': {
    title: 'HyperFrames: карта перелета в стиле Apple (от точки отправления к точке назначения)',
    summary:
      '8-секундная кинематографичная карта маршрута 16:9 — реалистичный зум по рельефу, анимированный самолет, скользящий по изогнутому маршруту от отправления к прибытию, подписанные города и кинетический счетчик расстояния. Построено на каталожном блоке HyperFrames `nyc-paris-flight` и переиспользуемо для любой пары городов.',
  },
  'hyperframes-logo-outro-cinematic': {
    title: 'HyperFrames: 4-секундное кинематографичное logo outro',
    summary:
      '4-секундное outro с логотипом в формате 16:9 — покомпонентная сборка wordmark, shimmer-sweep по финальному lockup, мягкий grain overlay и однострочный CTA. Основано на блоках HyperFrames `logo-outro`, `shimmer-sweep` и `grain-overlay`.',
  },
  'hyperframes-money-counter-hype': {
    title: 'HyperFrames: hype-ролик со счетчиком от $0 до $10K (9:16)',
    summary:
      '6-секундный вертикальный HyperFrames-клип 1080x1920 — счетчик в духе Apple от $0 до $10 000 с зеленой вспышкой, денежными частицами, иконкой пачки наличных и заголовком-kicker. Основано на каталожном блоке HyperFrames `apple-money-count`.',
  },
  'weread-year-in-review-video-template': {
    title: 'Видео-шаблон WeRead Year in Review',
    summary:
      'Вертикальный 9:16 HyperFrames-шаблон для годовых отчетов о чтении в стиле WeRead: теплая бумажная фактура, редакционная китайская типографика, переходы страниц, статистика чтения, следы заметок, ключевые интересы и финальная карточка читательского persona.',
  },
  'hyperframes-product-reveal-minimal': {
    title: 'HyperFrames: 5-секундный минималистичный product reveal',
    summary:
      '5-секундная композиция HyperFrames для премиального product reveal — темное полотно, один теплый акцент, медленный push-in титульной карточки, кинетическая kicker-строка и сдержанное движение. Агент рендерит MP4 из HTML + GSAP через Puppeteer; стоковое видео не требуется.',
  },
  'hyperframes-saas-product-promo-30s': {
    title: 'HyperFrames: 30-секундное SaaS product promo в стиле Linear',
    summary:
      '30-секундная композиция HyperFrames, смоделированная по продуктовым роликам в духе Linear / ClickUp — 3D-reveal интерфейса, beat-синхронная кинетическая типографика, анимированные UI-скриншоты и финальная карточка с logo outro. Собирается из каталожных HF-блоков `ui-3d-reveal`, `app-showcase`, `logo-outro` и shader-переходов между сценами.',
  },
  'hyperframes-social-overlay-stack': {
    title: 'HyperFrames: вертикальный стек соцоверлеев 9:16 (X · Reddit · Spotify · Instagram)',
    summary:
      '15-секундная вертикальная композиция HyperFrames 1080x1920, в которой поверх face-cam-loop по очереди наслаиваются четыре анимированные social card: пост X, реакция Reddit, карточка Spotify Now Playing и финальный Instagram follow CTA. Каждая карточка — каталожный блок HyperFrames; ценность в хореографии.',
  },
  'hyperframes-tiktok-karaoke-talking-head': {
    title: 'HyperFrames: talking head для TikTok 9:16 с караоке-субтитрами',
    summary:
      'Вертикальный HyperFrames-short 1080x1920 — talking head с TTS-озвучкой поверх face-cam-loop, с караоке-подобными пословно синхронизированными субтитрами, animated lower third и финальным TikTok follow overlay. Повторяет архетип may-shorts-19 из HyperFrames Student Kit.',
  },
  'hyperframes-website-to-video-promo': {
    title: 'HyperFrames: конвейер website-to-video (15-секундный маркетинговый монтаж)',
    summary:
      '15-секундная композиция HyperFrames 16:9, которая захватывает живой сайт в трех размерах viewport, а затем анимирует сцены с помощью chromatic radial split. Повторяет архетип hyperframes-sizzle из Student Kit, где сайт служит исходным ассетом.',
  },
  'hunched-character-animation': {
    title: 'Анимация сутулого персонажа',
    summary:
      'Инструкция для Seedance 2 по созданию walking-анимации на месте для заданного референса персонажа.',
  },
  'live-action-anime-adaptation-water-vs-thunder-breathing-duel': {
    title: 'Live-action-аниме-адаптация: дуэль водного и громового дыхания',
    summary:
      'Высокодетализированный 15-секундный промпт для live-action-адаптации аниме-дуэли с синими водными и золотыми электрическими эффектами.',
  },
  'luxury-supercar-cinematic-narrative': {
    title: 'Кинематографичный сюжет о роскошном суперкаре',
    summary:
      'Высокодетализированный multi-shot-промпт для Seedance 2.0 со стильным мужчиной, доберманами и винтажным суперкаром в туманном горном пейзаже.',
  },
  'magical-academy-storyboard-sequence': {
    title: 'Сториборд-секвенция магической академии',
    summary:
      'Детализированный сториборд-промпт для кинематографичной последовательности о magical girl в академии — от прибытия до магической дуэли.',
  },
  'modern-rural-aesthetics-healing-short-film-video-prompt': {
    title: 'Healing-короткометражка в эстетике современного rural',
    summary:
      'Детализированный three-shot-промпт для Seedance 2.0, создающий исцеляющую кинематографичную короткометражку в современной rural-aesthetic.',
  },
  'nightclub-flyer-atmospheric-animation': {
    title: 'Атмосферная анимация nightclub-флайера',
    summary:
      'Ненавязчивый анимационный промпт для Seedance 2.0, который оживляет фон и световые элементы, оставляя основной мотив неподвижным.',
  },
  'retro-hk-wuxia-film-aesthetic': {
    title: 'Эстетика ретро-HK wuxia-фильма',
    summary:
      'Сложный многосоставный видеопромпт, воссоздающий гонконгскую wuxia-эстетику 80-х и 90-х с превращением кота в человека.',
  },
  'seedance-2-0-15-second-cinematic-japanese-romance-short-film': {
    title: 'Seedance 2.0: 15-секундная кинематографичная японская romance-короткометражка',
    summary:
      'Высокодетализированный multi-scene-промпт на 15 секунд для кинематографичной и ультрареалистичной японской школьной romance-короткометражки.',
  },
  'seedance-2-0-80-year-old-rapper-mv': {
    title: 'Seedance 2.0: 80-летняя рэперша в музыкальном видео',
    summary:
      'Детализированный 15-секундный промпт для уличного рэп-клипа 16:9 с 80-летней женщиной и холодной неоново-фиолетово-синей палитрой.',
  },
  'sequence-and-movement-instruction-for-martial-arts-video': {
    title: 'Инструкция по последовательности и движению для видео о единоборствах',
    summary:
      'Видеопромпт для Seedance 2.0, который анимирует секвенцию по character sheet и подчеркивает конкретные движения и шаги.',
  },
  'soul-switching-mirror-magic-sequence': {
    title: 'Магическая зеркальная секвенция с обменом душами',
    summary:
      'Нарративный видеопромпт о магическом обмене душами у зеркала, с указаниями по камере и эмоциональными cues.',
  },
  'toaster-rocket-jumpscare': {
    title: 'Джампскейр с тостером-ракетой',
    summary:
      'Промпт для реалистичной домашней видеосцены, в которой пожилой мужчина пугается, когда тостер выстреливает хлебом как ракетой.',
  },
  'traditional-dance-performance': {
    title: 'Традиционное танцевальное выступление',
    summary:
      'Развернутый видеопромпт для Seedance 2.0 с изящным традиционным танцем, построенным на референсах хореографии и внешности.',
  },
  'video-seedance-three-kingdoms-guanyu-slaying-yanliang': {},
  'video-seedance-three-kingdoms-lyubu-yuanmen-archery': {},
  'video-seedance-three-kingdoms-zhaoyun-cradle-escape': {},
  'vintage-disney-style-pirate-crocodile-animation': {
    title: 'Пиратская крокодилья анимация в духе винтажного Disney',
    summary:
      'Многосценный нарративный промпт для классической disney-style-анимации с винтажным оттенком, крокодилом-пиратом и птицами-пиратами на корабле.',
  },
  'viral-k-pop-dance-choreography': {
    title: 'Вирусная K-pop-хореография',
    summary:
      'Детализированный промпт для Seedance 2.0, где персонаж танцует хореографию по 16-панельному storyboard-референсу.',
  },
  'wasteland-factory-chase': {
    title: 'Погоня по пустоши с фабрикой на ходу',
    summary:
      'Кинематографичный промпт для скоростной пустынной wasteland-сцены с шагающей индустриальной фабрикой и погоней на rebel bike.',
  },
  'game-ui-ancient-china-open-world-mmo-hud': {
    title: 'Игровой UI - древний Китай, HUD open-world MMO',
    summary:
      'Создает mockup внутриигрового HUD-скриншота для AAA open-world MMO о древнем Китае в кинематографичном фотореалистичном стиле Black Myth: Wukong, с акцентом на мечницу в туманной горной сцене и полным MMO-HUD (панель персонажа, миникарта, хотбар навыков, трекер квестов, чат).',
  },
  'illustration-crayon-kid-drawing-rework': {
    title: 'Иллюстрация - переработка детского рисунка восковыми мелками',
    summary:
      'Промпт для style transfer, который превращает любое референсное изображение в нарисованную от руки восковыми мелками иллюстрацию, будто ее сделал десятилетний ребенок. Исходная палитра заменяется яркими, игривыми мелковыми цветами на чистой белой бумаге, с детскими декоративными мотивами — замками, сладостями, звездами и радугами. Работает как image-to-image-редактирование в GPT-image-2.',
  },
  'social-media-post-sensational-girl-dance-storyboard-8-shots': {
    title: 'Пост для соцсетей - танцевальный сториборд стильной героини (8 кадров)',
    summary:
      'Полный набор промптов для сториборда из 8 кадров, предназначенный для генерации цельной танцевальной последовательности со стильным персонажем кадр за кадром. Включает общие глобальные style tokens, переиспользуемый negative prompt и восемь отдельных кадров (стартовая поза -> groove бедрами -> body wave -> поворот бедер на бит-дропе -> боковое покачивание бедрами -> бросок волос -> power stance -> финальная поза).',
  },
};
